import {AbstractService} from 'services/AbstractService';

const CUSTOMERS_LIST_URL = '/api/customers';

export class CustomersService extends AbstractService {
  list (accountId) {
    return this.client.get(CUSTOMERS_LIST_URL, {}, {accountId});
  }
}
